"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionSettingsInfoBar = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const QuestionSettingsInfoBar = (question, highlightRequired = false) => {
    let optionsText = null;
    const details = [];
    if (question.required) {
        details.push("Required");
    }
    if (question.questionType === "nominal" && question.allowMultipleChoices) {
        details.push("Multi-Vote Allowed");
    }
    if (details.length > 0) {
        optionsText = CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: `ℹ️ ${details.join(" | ")}`,
            size: adaptivecards_1.TextSize.Small,
            isSubtle: true,
            color: highlightRequired ? adaptivecards_1.TextColor.Attention : adaptivecards_1.TextColor.Default,
        });
    }
    return optionsText;
};
exports.QuestionSettingsInfoBar = QuestionSettingsInfoBar;
//# sourceMappingURL=QuestionSettingsInfoBar.js.map